const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/api";
export const ReturnQuery: any = {
    getReturnDetailByReturnId: Backofficebff + '/v1/return/getReturnDetailByReturnId',
    getReturnReason: Backofficebff + '/v1/return/getReturnReason',
    getReturnRejectedReason: Backofficebff + '/v1/return/getReturnRejectedReason',
    getReturnStatus: Backofficebff + '/v1/return/getReturnStatus',
    getRejectedLabelDetails: Backofficebff + '/v1/labeldetails/getlabeldetails',
    getDraftHistory: Backofficebff + '/v1/completeandconfirmrequest/draft-history',
    getReturnDetailByReturnIdForLostCargo: Backofficebff + '/v1/return/get-return-detail-by-returnId-for-lost-cargo',
    getBankConfigurationFromRule: Backofficebff + '/v1/return/get-customer-page-configuration',
    getPageRulesList: Backofficebff + '/v1/return/get-page-rules-list',
    getReturnRejectReturnRejectCountryActiveListByRule: Backofficebff + '/v1/return/get-return-reject-country-active',
    getReturnRejectShipmentVisibleRule: Backofficebff + '/v1/return/return-reject-shipment-visible-rule',
    getShowResetButtonRule: Backofficebff + '/v1/return/show-reset-button-rule',
    canStoreUserCreateRefund: Backofficebff + '/v1/return/can-store-user-create-refund',
};
